// extracted by mini-css-extract-plugin
export default {"divMain":"StepCard_divMain__yyyGW","divText":"StepCard_divText__tLsjQ"};